import React, { useCallback, useEffect, useRef } from 'react';
import { NavigationContainer, NavigationIndependentTree } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import NavigationElements, { MyAccountRouteName } from '../../models/NavigationElements';
import Help from './Help';
import Menu from './menu/Menu';
import IdVerification from './verification/IdVerification';
import MyProfile from './myprofile/MyProfile';
import MyRewards from './myrewards/MyRewards';
import MyTransactions from './mytransactions/MyTransactions';
import TransactionDetail from './mytransactions/TransactionDetail';
import Settings from './settings/Settings';
import SettingsTheme from './settings/SettingsTheme';
import SettingsLanguage from './settings/SettingsLanguage';
import SettingsNotifications from './settings/SettingsNotifications';
import Test401 from './Test401';
import { useAppDispatch } from '../../hooks/store-hook';
import { myAccountActions } from '../../store/myAccountSlice';

export type MyAccountStackParamList = Record<MyAccountRouteName, undefined>;

const Stack = createNativeStackNavigator<MyAccountStackParamList>();

export interface MyAccountNavigatorProps {
  initialRouteName: MyAccountRouteName;
}

const MyAccountNavigator = (props: MyAccountNavigatorProps) => {
  const dispatch = useAppDispatch();
  const lastRouteRef = useRef<MyAccountRouteName>(props.initialRouteName);

  // Keep the outer overlay aware of the current inner route (for swipe-to-dismiss on the root menu).
  const handleStateChange = useCallback(
    (state: any) => {
      const current = state?.routes?.[state?.index ?? 0]?.name as MyAccountRouteName | undefined;
      if (current && current !== lastRouteRef.current) {
        lastRouteRef.current = current;
        dispatch(myAccountActions.setCurrentRoute(current));
      }
    },
    [dispatch]
  );

  useEffect(() => {
    lastRouteRef.current = props.initialRouteName;
    dispatch(myAccountActions.setCurrentRoute(props.initialRouteName));
  }, [dispatch, props.initialRouteName]);

  return (
    <NavigationIndependentTree>
      <NavigationContainer onStateChange={handleStateChange}>
        <Stack.Navigator id="myaccount-stack" initialRouteName={props.initialRouteName} screenOptions={{ headerShown: false, animation: 'simple_push' }}>
          <Stack.Screen name={NavigationElements.menu} component={Menu} />
          <Stack.Screen name={NavigationElements.myProfile} component={MyProfile} />
          <Stack.Screen name={NavigationElements.idVerification} component={IdVerification} />
          <Stack.Screen name={NavigationElements.myRewards} component={MyRewards} />
          <Stack.Screen name={NavigationElements.myTransactions} component={MyTransactions} />
          <Stack.Screen name={NavigationElements.transactionDetail} component={TransactionDetail} />
          <Stack.Screen name={NavigationElements.settings} component={Settings} />
          <Stack.Screen name={NavigationElements.settingsTheme} component={SettingsTheme} />
          <Stack.Screen name={NavigationElements.settingsLanguage} component={SettingsLanguage} />
          <Stack.Screen name={NavigationElements.settingsNotifications} component={SettingsNotifications} />
          <Stack.Screen name={NavigationElements.help} component={Help} />
          <Stack.Screen name={NavigationElements.test401} component={Test401} />
        </Stack.Navigator>
      </NavigationContainer>
    </NavigationIndependentTree>
  );
};

export default MyAccountNavigator;
